import { NAME } from './constants';
import { apiProvider } from './api';
import Select from './components/Select.vue';
import { router } from './router';

export const PredmetPujcovna = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
